

export const setupFAQs = [
    {
        question: 'What\'s the difference between Google Search Console and Google Analytics?',
        answer: (<div>
            Google Search Console is the SEO command center.
            It shows the exact search terms people use to find your site, your ranking position in Google, and
            alerts you to technical issues that might be hurting your visibility.
            It answers: <div className="italic mb-4">"How am I performing on Google Search?"</div>

            Google Analytics is for audience behavior tracker.
            It reveals who your visitors are, where they come from, what pages they engage with,
            and if they complete goals like purchases or sign-ups. It answers:
            <div className="italic mb-4">"How are visitors engaging with my site?"</div>


            <div className="font-bold">
                In short: These are two essential, complementary tools for any successful website. GSC helps you get more traffic. GA helps you understand that traffic to drive conversions.
            </div>
        </div>)
    },
    {
        "question": "How will these services benefit my Shopify store?",
        "answer": (<div>These services are designed to improve the search visibility of your Shopify store, drive organic traffic, and ultimately increase conversions. By optimizing various on-page elements, your store will be better positioned to rank higher in search engine results, and attract more qualified traffic.</div>)
    },
    {
        question: "How do you ensure project success?",
        answer: "We follow a proven process: thorough discovery and research, strategic planning, iterative design with client feedback, rigorous testing, and comprehensive post-launch support. Sit back and relax, we have taken every step of the way.",
    },
    {
        "question": "How long does this process take?",
        "answer": (<div>Getting setup with the preliminary technologies takes a week to complete. After that, we
            begin the core work immediately. While SEO is a long-term strategy, we typically start to see initial
            data shifts and early indicators of growth within the first 2-4 weeks. </div>),
        "isHighlighted": true
    }
]





// TODO: Clean FAQs
export const pricingFAQs = [
    {
        question: "What will I receive as a client?",
        answer: "As a client, you will receive a comprehensive set of on-page SEO services tailored to enhance the visibility, traffic, and conversions of your website. These services will improve CTR, Average positions of the keywords, improvement in impressions and clicks."
    },
    {
        question: "What deliverables can I expect?",
        answer: "A detailed On-Page SEO audit report outlining the current state of your website and recommendations for improvement."
    },
    {
        question: "What is the timeline for the project?",
        answer: "This is monthly retainer SEO work, if you work with me for minimum of six months, you will get more better results for your website, keywords will improve for sure."
    },
    {
        question: "Will I receive ongoing support after the initial optimizations?",
        answer: "Yes, ongoing support and maintenance are available to ensure the continued success of your SEO efforts. Whether you need further optimizations, monitoring, or advice on SEO best practices."
    }
]


// Taken from https://www.marcfriedmanportfolio.com/
export const otherFAQs = [
    {
        question: "How long does a typical project take?",
        answer: "Project timelines vary based on complexity and scope. A simple landing page typically takes 2-3 weeks, while a full website redesign takes 6-8 weeks, and custom SaaS applications can take 12-16 weeks. We provide detailed timelines during our initial consultation.",
    },
    {
        question: "What's included in your web development service?",
        answer: "Our web development service includes custom design, responsive development, SEO optimization, performance optimization, security implementation, content management system setup, analytics integration, and 30 days of post-launch support. We also provide training and documentation.",
    },
    {
        question: "Do you work with clients internationally?",
        answer: "Yes! I work with clients across three continents and have experience with international projects. All communication is conducted in English, and I'm flexible with time zones to accommodate meetings and project collaboration.",
    },
    {
        question: "What technologies do you use?",
        answer: "I use modern, proven technologies including React, Next.js, TypeScript, Node.js, PostgreSQL, Supabase, Tailwind CSS, and Framer Motion. For design, I work with Figma, Adobe Creative Suite, and maintain comprehensive design systems.",
    },
    {
        question: "What's your pricing structure?",
        answer: "Pricing varies based on project scope and complexity. We offer transparent, fixed-price quotes after our initial consultation. Payment is typically structured in milestones: 50% to start, 25% at design approval, and 25% upon completion. No hidden fees or surprises.",
    },
]


export const allFAQs = {
    setupFAQs: setupFAQs
}